module.exports = __webpack_public_path__ + "img/59.03b1fe6b.jpg";